import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setView({ commit }, view) {
    commit(types.SET_VIEW, view)
  },
  setStatus({ commit }, status) {
    commit(types.SET_STATUS, status)
  },
  setSearchTerm({ commit }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setStartDate({ commit }, date) {
    commit(types.SET_START_DATE, date)
  },
  setEndDate({ commit }, date) {
    commit(types.SET_END_DATE, date)
  },
  setTech({ commit }, tech) {
    commit(types.SET_TECH, tech)
  },
  async getDashboardResults({ commit, dispatch }, { dashboard, searchOptions }) {
    if (dashboard) {
      // todo(bwills): this kinda feels dirty
      const r = await startLoading(dispatch, 'getDashboard', () =>
        http.get(`dashboard/${dashboard}`, {
          params: searchOptions
        })
      )
      return r.data
    }
  },
  async getCompanyNumberScansOverall({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getCompanyNumberScansOverall', () =>
      http.get(`dashboard/CountsByStatus`, {
        params: searchOptions
      })
    )
    commit(types.COMPANY_NUMBER_SCANS_OVERALL, r.data)
    return r.data
  },
  async getCompanyNumberScans({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getCompanyNumberScans', () =>
      http.get(`dashboard/GetServiceRequestBreakdownSummary`, {
        params: searchOptions
      })
    )
    commit(types.COMPANY_NUMBER_SCANS, r.data.scanInProgress)
    return r.data.scanInProgress
  },
  async getCompanyAvgScanTimes({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getCompanyAvgScanTimes', () =>
      http.get(`dashboard/CompanyAvgScanTimes`, {
        params: searchOptions
      })
    )
    commit(types.COMPANY_AVG_SCAN_TIMES, r.data)
    return r.data
  },
  async getPersonalYesterdayScans({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getPersonalYesterdayScans', () =>
      http.get(`dashboard/CountsByMasterTechDate`, {
        params: searchOptions
      })
    )
    commit(types.PERSONAL_YESTERDAY_SCANS, r.data)
    return r.data
  },
  async getPersonalAvgScans({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getPersonalAvgScans', () =>
      http.get(`dashboard/CountsByMasterTechDateType`, {
        params: searchOptions
      })
    )
    commit(types.PERSONAL_AVG_SCANS, r.data)
    return r.data
  },
  async getPersonalAvgScanTimes({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getPersonalAvgScanTimes', () =>
      http.get(`dashboard/MasterTechAvgScanTimes`, {
        params: searchOptions
      })
    )
    commit(types.PERSONAL_AVG_SCAN_TIMES, r.data)
    return r.data
  },
  async getPersonalAvgCycleTimes({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getPersonalAvgCycleTimes', () =>
      http.get(`dashboard/AverageTotalCycleTime`, {
        params: searchOptions
      })
    )
    commit(types.PERSONAL_AVG_CYCLE_TIMES, r.data)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/actions.js